<template>
<div class="leads-agenda" id="leads-agenda">
  <Breadcrumbs
    :breadcrumbs="[
      { title: this.$t('menu.leads'), disabled: true },
      { title: this.$t('menu.leads-agenda'), disabled: true}
    ]">

  </Breadcrumbs>

  <div class="evollu-form">
    <div class="form-row">
      <div class="col-12 col-md-4">
        <div>
          <label class="form-label">{{$t('agenda.appointments.facility')}}</label>
          <multiselect
            v-model="filters.facilities"
            :options="controloQualidadeFacilitiesOptions"
            track-by="id"
            label="name"
            select-label=""
            selected-label=""
            deselect-label=""
            placeholder="---"
            :allow-empty="true"
            :multiple="false"
            :searchable="true"
            :disabled="controloQualidadeFacilitiesOptions.length === 1"
          >
            <template slot="clear">
                <span class="multiselect__clear" v-if="filters.facilities.length"
                      @mousedown.prevent.stop="clearFacilitiesMultiselect"></span>
            </template>

          </multiselect>
        </div>
      </div>

      <div class="col-12 col-md-4" v-if="isAdmin">
        <div>
          <label class="form-label">{{$t('leads.agenda.filters.user')}}</label>
          <multiselect
            v-model="filters.users"
            :options="usersOptions"
            track-by="id"
            label="name"
            select-label=""
            selected-label=""
            deselect-label=""
            placeholder="---"
            :allow-empty="true"
            :multiple="false"
            :searchable="true"
            :disabled="usersOptions.length === 1 || filters.facilities.length === 0"
          >
            <template slot="clear">
                <span class="multiselect__clear" v-if="filters.users.length"
                      @mousedown.prevent.stop="clearUsersMultiselect"></span>
            </template>

          </multiselect>
        </div>
      </div>
    </div>
  </div>
  <div class="calendar-wrapper">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :color="'#29c4a9'"
      :background-color="'#f5f5f5'"
      :is-full-page="false">
    </loading>

    <FullCalendar
      v-if="hasLoadedEntities"
      id="leadsAgenda"
      :key="calendarKey"
      ref="eventsCalendar"
      :options="calendarOptions">
      <template v-slot:eventContent='data'>
        <Event
          :view="data.view"
          :event="data.event"
        />
      </template>

    </FullCalendar>

    <LeadDetail
      v-if="showLeadDetails"
      :service="component.service"
      :selectedLead="selectedLead"
      :entities="entities"
      :entitiesWrite="entitiesWrite"
      :salePriceEntitiesRead="salePriceEntitiesRead"
      :salePriceEntitiesWrite="salePriceEntitiesWrite"
      @cancel="leadDetailsClosed"
      @updatedSession="leadSessionUpdated"
      @eventCreated="updateCalendar"
    />

    <EventFormModal
      v-if="showEventForm"
      v-bind="propsEventForm"
      :service="component.service"
      :prefilledFacility="Object.keys(this.filters.facilities).length > 0 ? this.filters.facilities : null"
      :prefilledUser="Object.keys(this.filters.users).length > 0 ? this.filters.users : null"
      :lead="selectedLead"
      @modal-closed="modalClosed"
      @event-created="updateCalendar"
      @event-updated="eventUpdated"
      @event-deleted="updateCalendar"
      @openLeadDetail="handleOpenLeadDetail"
      :showDatePickers="isUpdating || !selectedLead"
      :eventsSchedules="events.map(event => {
          return {
            'start': event.start,
            'end': event.end
          }
        })"
    />
  </div>
</div>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import FullCalendar from "@fullcalendar/vue";
import Loading from 'vue-loading-overlay'
import moment from "moment";
import ApiService from "@/api/ApiService";
import axios from "axios";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import momentPlugin from "@fullcalendar/moment";
import interactionPlugin from "@fullcalendar/interaction";
import LocalStorageHelper from "@/local-storage/LocalStorageHelper";
import {FILTERS_CALENDAR_DAY, FILTERS_CALENDAR_VIEW, FILTERS_LEADS_AGENDA} from "@/local-storage/LocalStorageKeys";
import Event from "@/components/leads-agenda/Event";
import LeadDetail from "@/components/leads/LeadDetail";
import {LeadsAgendaService, LeadsService} from "@/api/LeadsService";
import Multiselect from 'vue-multiselect'
import {flatten, uniqBy} from "lodash";
import Errors from "@/utils/StandardErrors";
import {FORM_DEFAULTS} from "@/components/clinical/appointments/config";
import EventFormModal from "@/components/leads-agenda/EventFormModal";


const calendarMinTime = '08:00:00'
const calendarMaxTime = '20:00:00'
const ActivityControloQualidadeId = 11


export default {
  components: {EventFormModal, LeadDetail, Event, Loading, Breadcrumbs, FullCalendar, Multiselect},
  props: {
    serviceSlug: {
      type: String,
      required: true
    },
    component: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      isUpdating: false,
      isLoading: true,
      calendarKey: 0,
      calendarAPI: null,
      cancellationEventsCallback: null,
      events: [],
      hasLoadedLocalStorage: false,
      controloQualidadeFacilitiesOptions: [],
      usersOptions: [],
      usersByFacilities: [],
      filters: {
        facilities: {},
        users: {}
      },
      calendarOptions: {
        eventSources: [{
          events: (options, callback) => {
            if (this.cancellationEventsCallback !== null) {
              this.cancellationEventsCallback()
            }

            let params = {
              startDate: moment(options.start).format('YYYY-MM-DD'),
              facilities: this.filters.facilities.id,
              users: this.isAdmin ? this.filters.users.id : this.$auth.user().id
            }

            if (moment(options.end).format('HH:mm:ss') === '00:00:00') {
              params.endDate = moment(options.end).subtract(1, 'second').format('YYYY-MM-DD')
            }

            this.isLoading = true
            ApiService.cancelableQuery(`${this.component.service.url}/agenda/events`, params, new axios.CancelToken(c => {
              this.cancellationEventsCallback = c
            }))
              .then(response => {
                this.events = response.data.data.map(event => ({
                  ...event,
                  start: this.$options.filters.localTime(event.start),
                  end: this.$options.filters.localTime(event.end),
                }))

                callback(this.events.map(event => ({
                  ...event,
                  borderColor: event.type && event.type.color ? event.type.color : '#29c4a9',
                  className: event.type && event.type.name === 'unavailability' ? 'background-striped' : ''
                })))
              })
              .catch(errs => {
                if (!axios.isCancel(errs)) {
                  console.log(errs)
                }
              })
              .finally(() => {
                this.cancelationReadCallback = null
                this.isLoading = false
              })
          }
        }],
        lazyFetching: false,
        eventColor: '#29c4a9',
        plugins: [dayGridPlugin, timeGridPlugin, momentPlugin, interactionPlugin],
        dayMaxEventRows: 3,
        headerToolbar: {
          left: 'title',
          right: 'timeGridDay timeGridWeek dayGridMonth prev next'
        },
        eventDisplay: 'block',
        buttonText: {
          today: this.$t('agenda.buttons.today'),
          month: this.$t('agenda.buttons.month'),
          week: this.$t('agenda.buttons.week'),
          day: this.$t('agenda.buttons.day'),
          listMonth: this.$t('agenda.buttons.listMonth'),
        },
        customButtons: {
          timeGridDay: {
            text: this.$t('agenda.buttons.day'),
            click: (event) => {
              this.calendarAPI.gotoDate(this.getNextViewStart())
              this.calendarAPI.changeView('timeGridDay')
            }
          },
          timeGridWeek: {
            text: this.$t('agenda.buttons.week'),
            click: () => {
              this.calendarAPI.gotoDate(this.getNextViewStart())
              this.calendarAPI.changeView('timeGridWeek')
            }
          }
        },
        initialDate: LocalStorageHelper.get(FILTERS_CALENDAR_DAY, false),
        initialView: LocalStorageHelper.get(FILTERS_CALENDAR_VIEW) || 'dayGridMonth',
        locale: this.selectedLanguage,
        firstDay: 1,
        hiddenDays: [0],
        allDayContent: this.$t('agenda.buttons.all-day'),
        allDayClassNames: 'calendar__allday__label',
        slotMinTime: calendarMinTime,
        slotMaxTime: calendarMaxTime,
        titleFormat: 'MMMM, YYYY',
        displayEventEnd: true,
        nowIndicator: true,
        slotDuration: '00:30',
        slotLabelFormat: 'HH:mm',
        slotLabelInterval: '01:00',
        height: 'auto',
        dayHeaderFormat: 'ddd D',
        eventTimeFormat: 'H:mm',
        editable: true,
        weekends: true,
        allDaySlot: false,
        selectable: true,
        selectMirror: true,
        unselectAuto: true,
        navLinks: true,
        disableResizing: true,
        dayHeaderContent: (content) => {
          return {
            html: `
          <div class="calendar__header__label">
            <div class="calendar__header__label__day view__${content.view.type}">` + moment(content.date).locale(this.selectedLanguage === 'gb' ? 'en' : this.selectedLanguage).format('DD') + `</div>
            <div class="calendar__header__label__weekday">` + moment(content.date).locale(this.selectedLanguage === 'gb' ? 'en' : this.selectedLanguage).format('dddd') + `</div>
          </div>
        `
          }
        },
        eventClick: this.eventSelected,
        eventDrop: this.updateEventFromUI,
        // eventResize: this.updateEventFromUI,
        select: this.eventCreated,
        navLinkDayClick: this.dayClicked,
        datesSet: this.datesDidUpdate
      },
      showLeadDetails: false,
      selectedLead: null,
      entities: [],
      entitiesWrite: [],
      salePriceEntitiesRead: [],
      salePriceEntitiesWrite: [],
      hasLoadedEntities: false,
      propsEventForm: {
        facilities: [],
        event: null,
        fromEvent: {
          start: null,
          end: null
        }
      },
      showEventForm: false
    }

  },
  created: function () {

  },
  mounted: function () {
    this.loadEntities().then(() => {
      this.calendarAPI = this.$refs.eventsCalendar.getApi()
      if (this.calendarAPI) {
        this.calendarAPI.setOption('locale', this.selectedLanguage)
      }

      // load users options
      if(this.isAdmin) {
        let facilitiesAdmin = this.entitiesAdmin
        facilitiesAdmin = facilitiesAdmin.filter(elem => elem.activity_id === ActivityControloQualidadeId && elem.status === 0)
        facilitiesAdmin = uniqBy(flatten(facilitiesAdmin.map(item => {
          return item.facilities
        })), 'id')

        LeadsAgendaService.getUsersOptions(facilitiesAdmin.map(facility => facility.id)).then(resp => {
          this.usersByFacilities = resp.data.data
        }).catch(err => {
          console.log(err)
        })
      }
    })
  },
  methods: {
    handleOpenLeadDetail: function (lead) {
      this.showEventForm = false
      setTimeout(() => {
        this.showLeadDetails = true
      }, 500)
    },
    /*datesDidUpdate: function () {
      this.$nextTick(() => {
        this.loadEntityActivityUsersRead()
          .then(() => {
            return this.loadLocalStorage()
          })
        this.loadEntityActivityUsersWrite()
        LocalStorageHelper.set(FILTERS_CALENDAR_VIEW, this.calendarAPI.view.type)
        LocalStorageHelper.set(FILTERS_CALENDAR_DAY, this.moment(this.calendarAPI.view.currentStart).format('YYYY-MM-DD'), false)
      })
    },*/
    datesDidUpdate: function () {
      this.$nextTick(async () => {
        await this.loadLocalStorage()
        LocalStorageHelper.set(FILTERS_CALENDAR_VIEW, this.calendarAPI.view.type)
        LocalStorageHelper.set(FILTERS_CALENDAR_DAY, this.moment(this.calendarAPI.view.currentStart).format('YYYY-MM-DD'), false)
      })
    },
    eventUpdated: function ({ event }) {
      this.isUpdating = false
      this.propsEventForm.event = event
      this.showEventForm = false
      this.loadEvents()
    },
    modalClosed: function () {
      this.selectedLead = null
      this.propsEventForm = {}
      this.showEventForm = false
    },
    updateCalendar: function () {
      this.propsEventForm = {}
      this.showEventForm = false
      this.showLeadDetails = false
      this.loadEvents()
    },
    eventSelected: function ({event}) {
      if (event.extendedProps.lead) {
        this.selectedLead = event.extendedProps.lead
      }

      this.isUpdating = true
      this.propsEventForm = {
        event: {
          id: event.id,
          ...event.extendedProps,
          source: null,
          start: moment(event.start).format('YYYY-MM-DD HH:mm:ss'),
          end: moment(event.end).format('YYYY-MM-DD HH:mm:ss')
        },
        facilities: this.controloQualidadeFacilitiesOptions,
      }
      this.showEventForm = true

    },
    loadLocalStorage: function() {
      return new Promise(resolve => {
        let state = LocalStorageHelper.get(FILTERS_LEADS_AGENDA)

        if(state !== null) {

        }
        this.hasLoadedLocalStorage = true
        resolve()
      })
    },
    loadEvents: function () {
      this.calendarAPI.refetchEvents()
    },
    persistFilters: function () {
      let filters = {
        facilities: this.filters.facilities.id,
        users: this.filters.users.id
      }

      LocalStorageHelper.set(FILTERS_LEADS_AGENDA, filters)
    },
    loadEntities: function () {
      return new Promise(resolve => {
        this.isLoading = true
        LeadsService.getEntities()
          // eslint-disable-next-line camelcase
          .then(({ leads_read, leads_write, leads_sale_price_read, leads_sale_price_write }) => {
            this.entities = leads_read // eslint-disable-line camelcase
            this.entitiesWrite = leads_write // eslint-disable-line camelcase
            this.salePriceEntitiesRead = leads_sale_price_read // eslint-disable-line camelcase
            this.salePriceEntitiesWrite = leads_sale_price_write // eslint-disable-line camelcase

            this.controloQualidadeFacilitiesOptions = this.entitiesWriteFull
            this.controloQualidadeFacilitiesOptions = this.controloQualidadeFacilitiesOptions.filter(elem => elem.activity_id === ActivityControloQualidadeId && elem.status === 0)
            this.controloQualidadeFacilitiesOptions = uniqBy(flatten(this.controloQualidadeFacilitiesOptions.map(item => {
              return item.facilities
            })), 'id')

            if(this.controloQualidadeFacilitiesOptions.length === 1) {
              this.filters.facilities = this.controloQualidadeFacilitiesOptions[0]
            }
            this.hasLoadedEntities = true
          }).catch(err => console.log(err))
          .finally(() => {
            this.isLoading = false
            setTimeout(() => {
              resolve()
            }, 500)
          })
      })

    },
    leadDetailsClosed: function () {
      this.showLeadDetails = false
      setTimeout(() => {
        this.showEventForm = true
      })
    },
    leadSessionUpdated: function ({ lead }) {
      this.selectedLead = lead
    },
    getNextViewStart: function () {
      let start = moment(this.calendarAPI.view.currentStart)
      let end = moment(this.calendarAPI.view.currentEnd)
      let now = moment()
      if (start.isSameOrBefore(now) && end.isSameOrAfter(now)) {
        return now.toISOString()
      }
      return start.toISOString()
    },
    clearFacilitiesMultiselect: function () {
      this.filters.facilities = []
    },
    clearUsersMultiselect: function () {
      this.filters.users = []
    },
    updateEventFromUI: function ({event, revert}) {
      try {
        if (!this.hasPermissionToEditEvent(event)) {
          throw new Error('Missing Permissions')
        }

        const eventId = parseInt(event.id)
        const eventData = this.events.find(event => event.id === eventId)
        if(eventData === undefined) {
          throw new Error('Could not find an event with the given id')
        }

        let params = {
          ...eventData
        }
        params.start = this.$options.filters.utcTime(event.start)
        params.end = this.$options.filters.utcTime(event.end)

        if(params.type) {
          params.type = params.type.id
        }

        LeadsAgendaService.updateEvent(eventData.id, params)
          .then(response => {
            this.showToast(this.$t('leads.agenda.event_updated_success'), this.$store.state.successToastOptions)
          })
          .catch(errs => {
            console.log(errs)
            let errorMessage = this.$t('clinical.appointments.something_went_wrong')
            if (errs.hasOwnProperty('response') && errs.response.status) {
              const status = errs.response.status
              if (status === 403) {
                errorMessage = this.$t('clinical.appointments.missing_permissions')
              } else if (status === 422) {
                const errorBag = new Errors()
                errorBag.record(errs.response.data.errors, 'leads.agenda.events_errors.')
                errorMessage = this.$t(errorBag.first())
              }
            }
            this.showToast(errorMessage, this.$store.state.errorToastOptions)
            revert()
          })
      } catch (errors) {
        console.log(errors)
        revert()
      }
    },
    hasPermissionToEditEvent: function(event) {
      return this.controloQualidadeFacilitiesOptions.some(facility => facility.id === event.extendedProps.facility.id)
    },
    eventCreated: function({start, end, allDay, fromDefault = false}) {
      if (!this.controloQualidadeFacilitiesOptions.length) {
        this.calendarAPI.unselect()
        return
      }

      this.propsEventForm.facilities = this.controloQualidadeFacilitiesOptions

      if (start && end) {
        start = moment(start)
        end = moment(end)
        if (allDay) {
          // If its same day get round up the next start if not select the calendar slotMinTime plus START_INCREMENT
          if (start.isSame(new Date(), 'day') && moment().isAfter(start)) {
            start = moment(this.getNextViewStart()).add(FORM_DEFAULTS.NEXT_START_INCREMENT, FORM_DEFAULTS.NEXT_START_INTERVAL).startOf(FORM_DEFAULTS.NEXT_START_INTERVAL)
            end = start.clone().add(FORM_DEFAULTS.START_INCREMENT, FORM_DEFAULTS.INCREMENT_INTERVAL)
            // If its not creating from the plus button
          } else if (!fromDefault) {
            start = moment(`${start.format('YYYY-MM-DD')} ${this.calendarOptions.slotMinTime}`)
            end = start.clone().add(FORM_DEFAULTS.START_INCREMENT, FORM_DEFAULTS.INCREMENT_INTERVAL)
          }
        }


        this.propsEventForm.fromEvent = {
          start: start.format('YYYY-MM-DD HH:mm:ss'),
          end: end.format('YYYY-MM-DD HH:mm:ss'),
          userId: this.isAdmin ? this.filters.users.id : this.$auth.user().id
        }

        this.showEventForm = true
      }
    }
  },
  computed: {
    selectedLanguage: function () {
      return this.$i18n.locale()
    },
    eventsPermission: function () {
      return this.component.service.user_permissions.filter(permission => permission.info_type === 2200)
    },
    entitiesWriteFull: function () {
      return this.component.service.entities.filter(entity => this.eventsPermission.some(permission => (permission.entity_id === entity.id || permission.entity_id === null) && permission.access_type >= 2))
    },
    isAdmin: function () {
      return this.component.service.user_permissions.some(permission => permission.info_type === 2200 && permission.access_type === 3)
    },
    entitiesAdmin: function () {
      return this.component.service.entities.filter(entity => this.eventsPermission.some(permission => (permission.entity_id === entity.id || permission.entity_id === null) && permission.access_type >= 3))
    }
  },
  watch: {
    facilities: function (facilities) {
      this.calendarAPI.setOption('selectable', facilities.length > 0)
    },
    'filters.facilities': {
      handler: function (val) {
        if(val.length === 0) {
          this.filters.users = []
        } else if(this.isAdmin) {
          this.usersOptions = this.usersByFacilities.filter(val => val.facility_id === this.filters.facilities.id)[0].users
          if(this.usersOptions.length === 1) {
            this.filters.users = this.usersOptions[0]
          }
        }

        this.persistFilters()
        this.loadEvents()
      },
      deep: true
    },
    'filters.users': {
      handler: function (val) {
        this.persistFilters()
        this.loadEvents()
      },
      deep: true
    },
    selectedLanguage: function (language) {
      if (this.calendarAPI) {
        this.calendarAPI.setOption('locale', language === 'gb' ? 'en' : language)
      }
    },
    sidebarMinimized: function() {
      if(this.calendarAPI) {
        this.calendarKey = this.calendarKey + 1
      }
    }
  }
}
</script>

<style lang='scss'>
// you must include each plugins' css
// paths prefixed with ~ signify node_modules
// @import '~@fullcalendar/core/main.css';
// @import '~@fullcalendar/daygrid/main.css';
// @import '~@fullcalendar/timegrid/main.css';

@mixin for-desktop {
  @media (min-width: 599px) {
    @content;
  }
}

#leads-agenda {
  .calendar-wrapper {
    position: relative;

    .vld-overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 500;

      .vld-background {
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgb(245, 245, 245);
        opacity: 0.3;
      }

      .vld-icon {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .fc-header-toolbar {
    button {
      background-color: transparent;
      -webkit-box-shadow: 0 0 4px 0 rgba(98, 106, 119, 0.25);
      box-shadow: 0 0 4px 0 rgba(98, 106, 119, 0.25);
      border-radius: 25px;
      border: none;
      color: #d4d4d4;
      padding-top: 0.3em;
      padding-bottom: 0.3em;
      padding-left: 1em;
      padding-right: 1em;

      &:hover {
        color: #6e6e6e;
      }

      &:not(:first-child) {
        margin-left: 1em;
      }

      // &:disabled {
      //   color:#d4d4d4;
      // }
      &.fc-button-active {
        color: #6e6e6e;
        font-weight: 600;
      }

      &.fc-prev-button {
        margin-left: 1.5em;
      }

      &.fc-next-button,
      &.fc-prev-button {
        padding: 0.3em;
        color: #6e6e6e;

        span {
          font-weight: bold;
          font-size: 1.3em;
        }
      }
    }

    .fc-toolbar-title {
      color: #414141;
      font-weight: 600;
      font-size: 1.5em;
    }
  }

  .fc-daygrid-event, .fc-timegrid-event {
    background-color: #e8e8e8 !important;
    border-left-width: 10px;
    border-right-width: 0px;
    border-top-width: 0px;
    border-bottom-width: 0px;
    border-radius: 0%;

    .fc-event-main {
      color: #6E6E6E !important;
      padding-left: 5px;
      overflow: hidden;
    }
  }

  .person-name {
    color: #414141 !important;
    font-weight: 600;
  }

  .fc-timegrid-slot-label {
    color: #414141;
  }

  td.fc-timegrid-slot {
    border: 0.5px solid #d3d3d3 !important;
  }

  .fc-timegrid-cols td,
  .fc-timegrid-slot.fc-timegrid-slot-label,
  .fc-theme-standard .fc-scrollgrid,
  .fc-direction-ltr .fc-timeGridWeek-view .fc-scrollgrid tr > *:first-child,
  .fc-direction-ltr .fc-timeGridDay-view .fc-scrollgrid tr > *:first-child {
    border: none !important;
  }

  .fc-timeGridWeek-view td.fc-timegrid-slot.fc-timegrid-slot-lane,
  .fc-timeGridDay-view td.fc-timegrid-slot.fc-timegrid-slot-lane {
    // border-top: solid !important;
    border-right: none !important;
    border-left: none !important;
  }

  .fc-timeGridWeek-view tr:first-of-type td.fc-timegrid-slot.fc-timegrid-slot-lane,
  .fc-timeGridDay-view tr:first-of-type td.fc-timegrid-slot.fc-timegrid-slot-lane {
    border-top: 0.5px solid #d3d3d3 !important;
  }

  .fc-scrollgrid-section.fc-scrollgrid-section-header.fc-scrollgrid-section-sticky > td {
    border: none;
  }

  .fc-dayGridMonth-view .fc-scrollgrid-section.fc-scrollgrid-section-body > td {
    border-left: 0.5px solid #d3d3d3 !important;
    border-right: 0.5px solid #d3d3d3 !important;
    border-bottom: 0.5px solid #d3d3d3 !important;
  }

  .fc-scrollgrid-section.fc-scrollgrid-section-header.fc-scrollgrid-section-sticky > td {
    border-bottom: 0.5px solid #d3d3d3 !important;
  }

  .fc-scrollgrid-section-sticky > td {
    background-color: transparent;
  }

  th.fc-day-today, td.fc-day-today {
    background-color: #ebebeb;
  }

  .fc-day-grid-event > .fc-content {
    white-space: normal;
    text-overflow: ellipsis;
    max-height: 20px;
  }

  .fc-day-grid-event > .fc-content:hover {
    max-height: none !important;
  }

  .calendar__allday__label {
    font-size: 0.9rem;
  }

  .fc-header-left, fc-header-center, fc-header-right {
    width: 100%;
    display: block;
  }

  .floating__button {
    position: fixed;
    z-index: 9999;
    color: #29c4a9;
    font-size: 2rem;
  }

  .fc-col-header-cell {
    color: #d3d3d3;

    &.fc-day-today {
      color: #6E6E6E;
    }
  }

  .calendar__header__label {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    & .calendar__header__label__weekday {
      font-size: 0.6rem;
      text-transform: uppercase;
      @include for-desktop {
        font-size: 1.1rem;
      }
    }

    & .calendar__header__label__day {
      font-size: 0.8rem;
      font-weight: bold;
      @include for-desktop {
        font-size: 2.1rem;
      }

      &.view__dayGridMonth {
        display: none !important;
      }
    }
  }

  // .fc td, .fc th, .fc-timegrid, .fc-timeGridWeek-view, .fc-view {
  //   border-style: double !important;
  //   border-width: 0px !important;
  //   border-color: #aaa !important;
  // }

  .fc-col-header-cell {
    border-style: double !important;
    border-width: 0px !important;
    border-color: #aaa !important;
  }

  .fc-scrollgrid-section-header {
    border-left-style: double !important;
    border-left-width: 0px !important;
    border-left-color: #aaa !important;
  }

  .fc-timegrid-slot {
    height: 50px !important;
  }

  .fc-button-primary {
    color: #fff;
    background-color: #29c4a9;
    border-color: #29c4a9;
  }

  .fc-content {
    white-space: initial !important;
  }
}

#leads-agenda {
  & span.fa.fa-upload {
    font-size: 1.5rem;
    margin-right: 5px;

    &:hover {
      cursor: pointer;
    }
  }
}
.background-striped {
  background: repeating-linear-gradient(45deg, #e8e8e8, #e8e8e8 10px, #d9d9d9 10px, #d9d9d9 20px)
}
</style>
